import React from "react";
import { FormattedMessage } from "react-intl";

export const WelcomeHeader = ({ text }) => {
  return (
    <div className="w3-center w3-large">
      <FormattedMessage id={text} defaultMessage="Page title" />
    </div>
  );
};
